// extracted by mini-css-extract-plugin
export var colorSquare = "_na-0";
export var container = "_na-h";
export var danger = "_na-5";
export var lightPink = "_na-8";
export var neutralBlue = "_na-7";
export var neutralYellow = "_na-6";
export var normal = "_na-1";
export var primary = "_na-2";
export var primaryLight = "_na-3";
export var selected = "_na-i";
export var solidBlack = "_na-g";
export var solidGreen = "_na-b";
export var solidLightBlue = "_na-d";
export var solidNavy = "_na-c";
export var solidOrange = "_na-f";
export var solidPink = "_na-e";
export var solidRed = "_na-9";
export var solidYellow = "_na-a";
export var success = "_na-4";